const HOSTS: Record<string, string> = {
  DEV: 'https://collections.uat.ceviant.cloud/paymentgateway',
  PROD: 'https://collections.ceviant.co/paymentgateway',
};

/**
 * Resolves the payment gateway host for a merchant-supplied mode.
 *
 * An unrecognised or absent mode falls back to REACT_APP_BASE_URL rather
 * than defaulting to production, so a merchant typo cannot send test
 * traffic to the live gateway.
 */
export const resolveBaseUrl = (mode?: string): string | undefined =>
  (mode ? HOSTS[mode] : undefined) ?? process.env.REACT_APP_BASE_URL;
